export const TRANSPORT_TYPES = ['fcl', 'lcl'] as const

export type TransportType = (typeof TRANSPORT_TYPES)[number]
